// Components
import { Dropdown, message } from 'antd';
import { AddIcon, NewPlaylistIcon } from '../../../Icons';
import { Tooltip } from '../../../Tooltip';

// Utils
import { memo } from 'react';
import { useNavigate } from 'react-router-dom';

// I18n
import { useTranslation } from 'react-i18next';

// Services
import { playlistService } from '../../../../services/playlists';

// Redux
import { fetchMyPlaylists } from '../../../../store/slices/yourLibrary';
import { useAppDispatch, useAppSelector } from '../../../../store/store';
import { uiActions } from '../../../../store/slices/ui';

export const AddPlaylistButton = memo(() => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const user = useAppSelector(
    (state) => state.auth.user,
    (prev, next) => prev?.id === next?.id
  );

  const { t } = useTranslation(['navbar']);

  const onClick = () => {
    if (!user) return dispatch(uiActions.openLoginTooltip());
    playlistService.createPlaylist(user?.id!, { name: t('My Playlist') }).then((playlist) => {
      message.success(t('Playlist created'));
      dispatch(fetchMyPlaylists());
      navigate(`/playlist/${playlist.data.id}`);
    });
  };

  return (
    <Dropdown
      placement='bottomRight'
      trigger={['click']}
      menu={{
        items: [
          {
            key: 'create',
            icon: <NewPlaylistIcon />,
            label: t('Create a new Playlist'),
            onClick,
          },
        ],
      }}
    >
      <button className='create-playlist-button' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#1f1f1f', border: 'none', color: '#fff', cursor: 'pointer', padding: '6px 12px', borderRadius: '500px', transition: 'all 0.2s ease', gap: '6px', fontSize: '13px', fontWeight: 700 }} onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#2a2a2a'; e.currentTarget.style.transform = 'scale(1.04)'; }} onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#1f1f1f'; e.currentTarget.style.transform = 'scale(1)'; }}>
        <AddIcon width={16} height={16} fill="currentColor" />
        <span>{t('Create')}</span>
      </button>
    </Dropdown>
  );
});
